import { render, staticRenderFns } from "./MobileNavigationMenuButton.vue?vue&type=template&id=85a731bc&"
import script from "./MobileNavigationMenuButton.vue?vue&type=script&lang=js&"
export * from "./MobileNavigationMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./MobileNavigationMenuButton.vue?vue&type=style&index=0&id=85a731bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports